import React from 'react'
import PropTypes from 'prop-types'
import { Modal, Switch } from 'antd'
import Input from '../inputs/Input'
import TextAreaInput from '../inputs/TextArea'
import TagsInput from '../inputs/TagsInput'
import UserIpInput from '../inputs/UsersIpInput'
import _ from 'lodash'
import './../../ui.style.scss'

class CreateUserGroupModal extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      userGroupTitle: undefined,
      disable: true,
      newDescription: undefined,
      selectedUsers: [],
      ip: [],
      masterFlag: false
    }
  }

  UNSAFE_componentWillReceiveProps (newProps) { // eslint-disable-line camelcase
    if (this.state.disable) {
      if (newProps.userGroupTitle && !_.isEqual(newProps.userGroupTitle, this.state.userGroupTitle)) { this.setState({ userGroupTitle: newProps.userGroupTitle }) }
      if (newProps.description && !_.isEqual(newProps.description, this.state.newDescription)) { this.setState({ newDescription: newProps.description }) }
      if (newProps.ip && !_.isEqual(newProps.ip, this.state.ip)) { this.setState({ ip: newProps.ip }) }
      if (newProps.masterFlag && !_.isEqual(newProps.masterFlag, this.state.masterFlag)) { this.setState({ masterFlag: newProps.masterFlag }) }
      if (newProps.selectedUsers && !_.isEqual(newProps.selectedUsers, this.state.selectedUsers)) { this.setState({ selectedUsers: newProps.selectedUsers }) }
    }
  }

  resetState = () => {
    const state = {
      userGroupTitle: undefined,
      disable: true,
      newDescription: undefined,
      selectedUsers: [],
      ip: [],
      masterFlag: false
    }
    this.setState({ ...state })
  }

  handleTitleChange =(e) => {
    const { value } = e.target
    this.setState({ userGroupTitle: value, disable: false })
  }

  onDescriptionChange =(e) => {
    const { value } = e.target
    this.setState({ newDescription: value, disable: false })
  }

  onChangeUser = (changedUser, isDelete) => {
    let { selectedUsers } = this.state
    if (isDelete) {
      const index = selectedUsers.findIndex(item => item === changedUser)
      if (index > -1) { selectedUsers.splice(index, 1) }
    } else {
      selectedUsers.push(changedUser)
    }
    setTimeout(() => {
      this.setState({ selectedUsers, disable: false })
    }, 100)
  }

  onChangeIp = (value) => {
    this.setState({ ip: value, disable: false })
  }

  handleMasterFlagChange = (value) => {
    this.setState({ masterFlag: value, disable: false })
  }

  handleSubmit = () => {
    const { userGroupTitle, newDescription, selectedUsers, ip, masterFlag } = this.state
    if (this.props.toEditUserGroup) {
      this.props.handleSubmit(userGroupTitle, newDescription, selectedUsers, ip, masterFlag)
    } else {
      this.props.handleSubmit(userGroupTitle, newDescription, selectedUsers, null, ip, masterFlag)
    }
  }

  render () {
    const { visible, handleCancel, title, loading, parentCompoent, okText, userList, onSearchUser, isSubmitDisabled } = this.props
    const { userGroupTitle, disable, newDescription, selectedUsers, ip, masterFlag } = this.state

    return (

      <Modal
        className='general-modal create-user-group-modal'
        visible={visible}
        closable={false}
        title={title}
        okButtonProps={{ disabled: !(!disable && userGroupTitle) || isSubmitDisabled, loading: loading }}
        onOk={this.handleSubmit}
        onCancel={handleCancel}
        okText={okText}
        cancelText='Cancel'
        afterClose={this.resetState}
        width='620px'
        centered
        destroyOnClose
        maskClosable={false}
      >
        <React.Fragment>
          <Input title='User Group' handleChange={this.handleTitleChange} value={userGroupTitle} placeholder='Enter User Group Name' />
          <TextAreaInput
            title='Description'
            placeholder='Enter description'
            inputName='description'
            onFocus={() => { }}
            onBlur={() => { }}
            value={newDescription}
            handleChange={this.onDescriptionChange}
          />
          <label className='user'> Users </label>
          <TagsInput
            containerClass='tags'
            selectedItems={selectedUsers}
            selectedDisplayItems={selectedUsers}
            keyParameter={'id'}
            tagList={userList || []}
            onChange={this.onChangeUser}
            placeholder='Select Users'
            parentCompoent={parentCompoent}
            displayParameter={'id'}
            mode={'multiple'}
            onSearch={onSearchUser}
          />
          <div className='user-ip'>
            <label className='user-groups'> Whitelisted IP </label>
            <UserIpInput
              containerClass='tags'
              // enableButton={enableButton}
              title='Default Values'
              // type={details.type}
              placeholder={'Enter IP Values'}
              inputName='defaultValues'
              value={ip || []}
              handleChange={this.onChangeIp}
              readOnly
            />
          </div>
          <div className='user-group-master-flag'>
            <label className='master-flag-label'> Block User Requests From a Non Whitelisted IP </label>
            <Switch checked={masterFlag} onChange={this.handleMasterFlagChange} />
          </div>
        </React.Fragment>

      </Modal>
    )
  }
}

CreateUserGroupModal.propTypes = {
  /** visible action of CreateUserGroupModal. */
  visible: PropTypes.bool,
  /** title  of CreateUserGroupModal. */
  title: PropTypes.string,
  /** handleCancel action of CreateUserGroupModal. */
  handleCancel: PropTypes.func,
  /** Function to be called on search user */
  onSearchUser: PropTypes.func,
  /** Boolean to disable submit button */
  isSubmitDisabled: PropTypes.bool
}

export default CreateUserGroupModal
